import React, { useState, useRef, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
  Box,
  FormHelperText,
  Autocomplete,
  Select,
  MenuItem,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// import { fetchSuppliersByCompanyId } from '../../../../redux/orderSlice';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getCompanyType,
  getIntegratedPlayerList,
} from "../../../../redux/authSlice";
import {
  fetchParentCompanyDetails,
  updateCompanyAPI,
  updatePendingCompany,
} from "../../../../redux/adminSlice";
import LinkedParentCompanyModal from "../LinkedParentCompanyModal";
import linkIcon from "../../../../assets/images/link.svg";

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format("LL");

// Create a new object with the shape of our input initial state variable.const

export const ADD_EDIT_COMPANY_VALIDATION = yup.object().shape({
  companyName: yup.string().required("Company Name cannot be empty."),
  url: yup.string().required("Company URL is required."),
  companyTypeId: yup.string().required("Company Tyoe is required."),

  // export: yup.boolean().oneOf([true], 'Export'),
  description: yup.string().required("Company Description is required."),
});
const EditPendingCompany = ({
  onSubmit,
  actionType,
  currentStep,
  className,
  step,
  linkedOrderList,
  totalRecordsLink,
  handleNextStep,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useSelector((state) => state.admin);
  const { orderId } = useParams();
  const linkedCompanyList = useSelector(
    (state) => state.admin.parentCompanyList || []
  );
  const companyTypeOptions = useSelector(
    (state) => state.auth.companyType || []
  );
  const IPlistOptions = useSelector((state) => state.auth.checkIPlist || []);
  const [companyType, setCompanyType] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [isExport, setIsExport] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // const defaultValues = {
  //     companyName: '',
  //     companyTypeId: '',
  //     url: '',
  //     description: '',
  //     isExport: ''
  // }

  const {
    createdDate,
    modifiedDate,
    rejectedReason,
    rejectedDate,
    isActive,
    // companyBuName,
    compabyLogo,
    user,
    firstName,lastName,prefix,
    ...rest
  } = location.state?.pendingCompanyDetails || {};
  delete rest.createdDate;
  delete rest.modifiedDate;
  delete rest.rejectedReason;
  delete rest.rejectedDate;
  delete rest.isActive;
  delete rest.companyLogo;
  delete rest.user;
  delete rest.firstName;
  delete rest.lastName;
  delete rest.prefix;
  const initialValues = location.state?.pendingCompanyDetails || {};

  // console.log(">>:: ADD COMPANY ::>>>", initialValues, actionType)
  useEffect(() => {
    dispatch(getCompanyType());
  }, [dispatch]);
  // console.log('company type list values', companyTypeOptions);

  useEffect(() => {
    // Simulate fetching data from an API
    dispatch(getIntegratedPlayerList());
  }, [dispatch]);

  useEffect(() => {
    const queryParams = {
      companyKeyId: initialValues.companyId,
      pageNumber: 1,
      pageSize: 12,
      searchText: "",
    };
    dispatch(fetchParentCompanyDetails(queryParams));
  }, [dispatch]);

  const handleChangeIPlist = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prev) => ({ ...prev, [name]: checked }));
  };
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleExportChange = (event) => {
    setIsExport(event.target.checked);
    setFieldValue("isExport", checked);
  };
  const handleEditCompanyChange = (formattedValues) => {
    console.log("handleEditCompanyChange", formattedValues);
    const companyData = formattedValues;
    dispatch(updatePendingCompany(companyData))
      .then((response) => {
        const companyDetails = response.payload;

        if (companyDetails.success === true) {
          navigate(-1);
        }
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
  };
  // console.log('Company Id is ', rest,  initialValues, 'linkedCompanyList', linkedCompanyList)
  return (
    <>
      <div className={className}>
        <div className="main-content">
          <nav aria-label="breadcrumb" className="bread-box">
            <div>
              <h1 className="fprimary">
                {location.state?.actionType === "edit"
                  ? "Edit company"
                  : "Add company"}
              </h1>
              <h5 className="">
                {location.state?.actionType === "edit" ? "Edit" : "Add"} Company
                details to create a new company
              </h5>
            </div>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {location.state?.actionType === "edit" ? "Edit" : "Add"}
                  Company
                </li>
              </ol>
            </div>
          </nav>
          <div className="card mt-3 bg-stage">
            {/* {location.state?.actionType === "edit" && (
                            <div className="ps-4 pe-4">
                                <h1 className="fprimary">Company Details</h1>
                            </div>
                        )} */}
            <Formik
              // initialValues={editValue || defaultValues}
              initialValues={{
                companyName: initialValues?.companyName || "",
                companyTypeId:
                  initialValues?.supplierCompany?.companyTypeId || "",
                url: initialValues?.url || null,
                description: initialValues?.description || null,
                isExport: initialValues?.isExport || "",
                companyRolesIds: initialValues?.companyRolesIds || [],
                parentCompanyId: initialValues?.parentCompanyId || 0,
                ...rest,
              }}
              enableReinitialize={true}
              // validationSchema={ADD_EDIT_COMPANY_VALIDATION}
              onSubmit={(values, { setSubmitting }) => {
                const companyRolesIds = Object.keys(checkedItems)
                  .filter((key) => checkedItems[key])
                  .map((key) => {
                    const foundItem = IPlistOptions.find(
                      (item) => item.company_rolename === key
                    );
                    return foundItem ? foundItem.company_role_id : null;
                  })
                  .filter((id) => id !== null);

                const formattedValues = {
                  companyRolesIds,

                  ...values,
                };
                console.log("AddEditCompany Submit:", formattedValues);
                if (location.state?.actionType === "edit") {
                  formattedValues.parentCompanyId = values.parentCompanyId === null ? 0 : values.parentCompanyId
                  handleEditCompanyChange({ ...formattedValues });
                }
                // onSubmit(formattedValues);
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                touched,
              }) => (
                // <form onSubmit={handleSubmit}>
                <Form onSubmit={handleSubmit}>
                  <div className="card-body m-3">
                    <div className="row">
                      <div className="col-md-4 cs-form mb-3">
                        <TextField
                          label={t("companyProfile.companyName")}
                          className="md-input"
                          name="companyName"
                          value={values.companyName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.companyName}
                          helperText={errors.companyName}
                        />
                      </div>
                      <div className="col-md-4 cs-form mb-3">
                        <FormControl className="md-input">
                          {/* <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        options={companyTypeList}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={companyTypeList.find(option => option.value === values.companyTypeId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'companyTypeId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('companyProfile.companyType')}
                                                error={touched.companyTypeId && Boolean(errors.companyTypeId)}
                                                helperText={touched.companyTypeId && errors.companyTypeId}
                                            />
                                        )}
                                    /> */}
                          <InputLabel id="company-label">
                            Company Type *
                          </InputLabel>
                          <Select
                            labelId="company-label"
                            name="companyTypeId"
                            label="companyType"
                            className="md-input"
                            // options={companyType}
                            // getOptionLabel={(option) => option.label || ''}
                            value={values.companyTypeId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.companyTypeId}
                          >
                            <MenuItem value="" disabled>
                              Select Company Type
                            </MenuItem>
                            {companyTypeOptions.map((option) => (
                              <MenuItem
                                key={option.companyTypeId}
                                value={option.companyTypeId}
                              >
                                {option.companyTypeName}
                              </MenuItem>
                            ))}
                          </Select>

                          <FormHelperText>
                            {touched.companyTypeId && errors.companyTypeId}
                          </FormHelperText>
                        </FormControl>
                        {values.companyTypeId === 9 && (
                          <div>
                            {IPlistOptions.map((item, index) => (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    checked={
                                      checkedItems[item.company_rolename] ||
                                      false
                                    }
                                    onChange={handleChangeIPlist}
                                    companyRolesIds
                                    name={item.company_rolename}
                                    value={item.company_role_id}
                                  />
                                }
                                label={item.company_rolename}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                      {/* </div> */}
                      <div className="col-md-4 cs-form mb-3">
                        <TextField
                          label={t("companyProfile.url")}
                          className="md-input"
                          name="url"
                          value={values.url}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.url}
                          helperText={errors.url}
                        />
                      </div>
                      <div className="col-md-12 cs-form mb-3">
                        <div className="d-flex align-items-center">
                          <h5 className="mb-0 mr-3">
                            Is Company Export? &nbsp;
                          </h5>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.isExport}
                                onChange={(e) =>
                                  handleExportChange(e, setFieldValue)
                                }
                                name="isExport"
                                color="primary"
                              />
                            }
                            // label={'Is Company Export?'}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 cs-form mb-3">
                        <TextField
                          label={t("companyProfile.companyDescription")}
                          className="md-input"
                          name="description"
                          multiline
                          rows={4}
                          value={values.description || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.description}
                          // helperText={.errors.description}
                          inputProps={{
                            maxLength: 300,
                          }}
                          helperText={`${
                            (values.description || "").length
                          }/300`}
                        />
                      </div>
                      {/* <div className="col-md-12 cs-form mb-3"> */}
                      {location.state?.actionType === "edit" && (
                        <div className="col-md-6 cs-form mb-3">
                          <TextField
                            fullWidth
                            variant="outlined"
                            className="md-input"
                            value={values.parentCompanyName}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    color="primary"
                                    onClick={handleOpenModal}
                                    component="span"
                                  >
                                    {/* <SearchOutlinedIcon /> */}
                                    <span className="ms-2">
                                      <img src={linkIcon} alt="Link" />
                                    </span>
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      )}
                      <div className="col-md-6 cs-form mb-3">
                        <TextField
                          // label={t("companyProfile.companyName")}
                          label={"Business Unit Name"}
                          className="md-input"
                          name="companyBuName"
                          value={values.companyBuName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.companyBuName}
                          helperText={errors.companyBuName}
                        />
                      </div>
                      {/* <div className="col-md-2 cs-form mb-2">
                        <FormControl className="md-input">
                          <InputLabel id="unit-label">Prefix *</InputLabel>
                          <Select
                            labelId="unit-label"
                            name="prefix"
                            value={values.prefix}
                            label="Prefix"
                            onChange={handleChange}
                            error={errors.prefix}
                            helperText={errors.prefix}
                          >
                            <MenuItem value="1">Ms</MenuItem>
                            <MenuItem value="2">Mr</MenuItem>
                            <MenuItem value="3">Mrs</MenuItem>
                          </Select>

                          <FormHelperText>
                            {touched.uPrefix && errors.uPrefix}
                          </FormHelperText>
                        </FormControl>
                      </div>
                      <div className="col-md-5 cs-form mb-3">
                        <TextField
                          // label={t("companyProfile.companyName")}
                          label={"First Name"}
                          className="md-input"
                          name="firstName"
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.firstName}
                          helperText={errors.firstName}
                        />
                      </div>
                      <div className="col-md-5 cs-form mb-3">
                        <TextField
                          // label={t("companyProfile.companyName")}
                          label={"Last Name"}
                          className="md-input"
                          name="lastName"
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.lastName}
                          helperText={errors.lastName}
                        />
                      </div> */}

                      {/* </div> */}
                      <div className="col-md-12 cs-form mb-3  ">
                        <h5>
                          Disclaimer: In order to link this company to its
                          parent company, click on Add
                        </h5>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-light grey-btn lg-btn"
                          onClick={() => navigate(-1)}
                        >
                          {t("createOrder.back")}
                        </button>
                        {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                                Create Order
                                
                            </Button> */}
                        <button
                          className="btn btn-primary greeen-btn lg-btn"
                          type="submit"
                          variant="contained"
                          // onClick={updateFormData} // Use onClick to trigger form submission
                          // disabled={ isValid || isSubmitting }
                        >
                          {/* Create Order */}
                          {/* {loading ? "Submitting..." : "Add"} */}
                          {location.state?.actionType !== "edit"
                            ? "Next"
                            : "Submit"}
                          {/*  t('createOrder.createOrderbtn') */}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <LinkedParentCompanyModal
              open={modalOpen}
              onClose={handleCloseModal}
              linkedCompanyList={linkedCompanyList}
          companyId={initialValues.parentCompanyId}
          linkedId={initialValues.companyId}
              // totalRecordsLink={totalRecordsLink}
              // orderDetails={orderDetails}
              // onLinkOrder={handleLinkOrder}
              // currentStep={currentStep}
              handleNextStep={handleNextStep}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default EditPendingCompany;
